module.exports = __webpack_public_path__ + "img/0-19.292f1018.gif";